import { connect } from 'react-redux'
import { selectCurrentTicketSearchResultTicketCount } from 'selectors/search'

import View from './view'

const select = state => {
  return {
    isEmpty: selectCurrentTicketSearchResultTicketCount(state) === 0,
  }
}

export default connect(select)(View)
